module.exports = __webpack_public_path__ + "static/media/8174Fun88Logo.bd17aa49.png";